import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Order as SchemaOrder } from '../schemas/Order';
import { type RelatedServicesInfo as SchemaRelatedServicesInfo } from '../schemas/RelatedServicesInfo';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateRelatedServicesContentType = 'application/json' as const;
export type UpdateRelatedServicesRequest = SchemaRelatedServicesInfo;
export type UpdateRelatedServicesResponses = LinkCommonErrorResponses & {
    /**
     * @description Variants info updated
     */
    '200': {
        'application/json': SchemaOrder;
    };
};
export type UpdateRelatedServicesResponseSuccess = UpdateRelatedServicesResponses['200']['application/json'];
export type UpdateRelatedServicesSearchParams = {
    signature: string;
};
export type UpdateRelatedServicesPathParameters = {
    store_slug: string;
    order_id: string;
};
export const UpdateRelatedServicesUrl = '/{store_slug}/related_services/{order_id}' as const;
export const UpdateRelatedServicesMethod = 'PATCH' as const;
export const getUpdateRelatedServicesUrl = (params: UpdateRelatedServicesPathParameters) =>
    UpdateRelatedServicesUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateRelatedServicesPathParameters) =>
        String(params[param])
    );
